import { render, staticRenderFns } from "./EditResortBannerspaces.vue?vue&type=template&id=48d4ed88&"
import script from "./EditResortBannerspaces.vue?vue&type=script&lang=js&"
export * from "./EditResortBannerspaces.vue?vue&type=script&lang=js&"
import style0 from "./EditResortBannerspaces.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports